import { makeStyles, Typography } from '@material-ui/core';
import TablePagination from '@mui/material/TablePagination';
import React, { useState, useEffect } from 'react';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableContainer from '@material-ui/core/TableContainer';
import { useTranslation } from 'react-i18next';
import { fromNewDateFormatToDDMMYYYYSlash, fromNewDateFormatToHHmmssSlash } from '../../Helpers/dateHelper';
import { ProductionStateLogStates } from '../../Config/constants';
// import { dataService } from '../../Services/data.service';
import { StandStillTypes } from '../../Config/constants'
// import InputAdornment from '@mui/material/InputAdornment';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import { Pencil } from 'lucide-react';
import ProductionStateDialog from '../Shared/Dialogs/ProductionStateDialog';
import FlagstoneTheme from '../../Config/flagstoneTheme';

export default function ProductionStateLineTable(props) {
    const classes = useStyles();
    const { t } = useTranslation();
    const [rows, setRows] = useState(null);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(25);

    // edit state
    const [edit, setEdit] = useState(false);
    const [selectedState, setSelectedState] = useState(null);

    useEffect(() => {
        setRows(props.rows);
    }, [props]);

    const updateRows = (updatedRow) => {
        let tempRows = rows;
        let index = tempRows.findIndex(x => x.id === updatedRow.id);
        tempRows[index] = updatedRow;
        setRows(tempRows);
    }

    const findState = (state) => {
        switch (state) {
            case ProductionStateLogStates.START:
                return <Typography>{t("Start")}</Typography>;
            case ProductionStateLogStates.STOP:
                return <Typography>{t("Stop")}</Typography>;
            case ProductionStateLogStates.FINISH:
                return <Typography>{t("Finish")}</Typography>;
            case ProductionStateLogStates.BOOK:
                return <Typography>{t("Book")}</Typography>;
            case ProductionStateLogStates.STANDSTILL:
                return <Typography>{t("Standstill")}</Typography>;
            case ProductionStateLogStates.SCRAP:
                return <Typography>{t("Scrap")}</Typography>;
            case ProductionStateLogStates.GENERAL:
                return <Typography>{t("General")}</Typography>;
            default:
                return <Typography>{t("UNKNOWN")}</Typography>;
        }
    }

    const findStandstillTitle = (state) => {
        switch (state) {
            case StandStillTypes.TECHNICAL:
                return <Typography>{t("TECHNICAL")}</Typography>;
            case StandStillTypes.PLANNED:
                return <Typography>{t("PLANNED")}</Typography>;
            case StandStillTypes.CLEANSTART:
                return <Typography>{t("CLEANSTART")}</Typography>;
            case StandStillTypes.CLEANSTOP:
                return <Typography>{t("CLEANSTOP")}</Typography>;
            default:
                return <Typography>{t("UNKNOWN")}</Typography>;
        }
    }

    const handleDisplayStateProductionScrapLower = (state) => {
        if (state.state === ProductionStateLogStates.SCRAP || state.state === ProductionStateLogStates.FINISH) {
            if (state.scrapLower !== undefined && state.scrapLower !== null && state.scrapLower !== "") {
                if (state.scrapLower) {
                    return <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}><img className={classes.arrowIcon} alt="scissorDown" src={process.env.PUBLIC_URL + '/img/scissorArrowDown.svg'} style={{ height: props.size === "M" ? "25px" : props.size === "S" ? "15px" : "0.8rem" }}></img><Typography>{t("SCRAP")}</Typography></div>
                } else {
                    return <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}><img className={classes.arrowIcon} alt="scissorDown" src={process.env.PUBLIC_URL + '/img/scissorArrowDown.svg'} style={{ height: props.size === "M" ? "25px" : props.size === "S" ? "15px" : "0.8rem" }}></img><Typography>{t("PROD")}</Typography></div>
                }
            }
        }
        else {
            return "";
        }
    }
    const handleDisplayStateProductionScrapUpper = (state) => {
        if (state.state === ProductionStateLogStates.SCRAP || state.state === ProductionStateLogStates.FINISH) {
            if (state.scrapUpper !== undefined && state.scrapUpper !== null && state.scrapUpper !== "") {
                if (state.scrapUpper) {
                    return <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}><img className={classes.arrowIcon} alt="scissorUp" src={process.env.PUBLIC_URL + '/img/scissorArrowUp.svg'} style={{ height: props.size === "M" ? "25px" : props.size === "S" ? "15px" : "0.8rem" }}></img><Typography>{t("SCRAP")}</Typography></div>
                } else {
                    return <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}><img className={classes.arrowIcon} alt="scissorUp" src={process.env.PUBLIC_URL + '/img/scissorArrowUp.svg'} style={{ height: props.size === "M" ? "25px" : props.size === "S" ? "15px" : "0.8rem" }}></img><Typography>{t("PROD")}</Typography></div>
                }
            }
        } else {
            return "";
        }
    }

    const handleDisplayStateStartStopFinish = (state) => {
        if (state === ProductionStateLogStates.START || state === ProductionStateLogStates.STOP || state === ProductionStateLogStates.FINISH) {
            return findState(state);
        } else {
            return "-";
        }
    }

    const handleDisplayStateStandstill = (state) => {
        if (state.state === ProductionStateLogStates.STANDSTILL) {
            return findStandstillTitle(state.standStillType);
        } else {
            return "-";
        }
    }

    const handleDisplayGrondstof = (state) => {
        if (state.bomIn === undefined || state.bomIn === null) return "-";
        if (state.state !== ProductionStateLogStates.START || state.state !== ProductionStateLogStates.STOP) {
            return state.bomIn.map((x) => {
                return JSON.parse(x.bomMetaData).map((y, index) => {
                    if (y.MetaData[0].Percentage > 0) {
                        return <Typography key={'GrondStofDisplay_' + index}>{y.MetaData[0].Percentage + "%" + " " + x.productDescription}</Typography>
                    }
                });
            });
        }
    }

    const formatShiftTime = (date) => {
        // show dd/mm hh:mm
        let newDate = new Date(date);
        let hours = newDate.getHours();
        let minutes = newDate.getMinutes();
        return newDate.getDate() + "/" + (newDate.getMonth() + 1) + " " + hours + ":" + (minutes < 10 ? '0' : '') + minutes
    }

    // const handleDisplayInputAfval = (state) => {
    //     if (handleDisplayStateStartStopFinish(state.state) !== "") {
    //         return <TextField className={classes.inputCell} fullWidth defaultValue={state.cuttingTrash} size="small"
    //             variant='outlined' type='number' onChange={(e) => sendAfvalAmount(e, state)} label={t("Hoeveelheid")} InputProps={{
    //                 endAdornment: <InputAdornment position="end">mm</InputAdornment>,
    //             }} />;
    //     } else {
    //         return null;
    //     }
    // }

    // const sendAfvalAmount = (e, state) => {
    //     let dateTime = new Date().toISOString();
    //     let productionStateOrderLog = {
    //         id: state.id,
    //         productionOrderLineId: state.productionOrderLineId,
    //         machineId: state.machineId,
    //         state: state.state,
    //         packer: state.packer,
    //         bookingPallet: state.bookingPallet,
    //         scrapUpper: state.scrapUpper,
    //         scrapLower: state.scrapLower,
    //         standStillType: state.standStillType,
    //         productId: state.productId,
    //         output: state.output,
    //         cuttingTrash: parseInt(e.target.value),
    //         isActive: state.isActive,
    //         insertedOn: state.insertedOn,
    //         insertedByUserId: state.insertedByUserId,
    //         updatedOn: dateTime,
    //         updatedByUserId: parseInt(props.props.user.userInfo.sub)
    //     }
    //     dataService.updateProductionStateOrderLog(productionStateOrderLog).then(result => {
    //         console.log(result);
    //     }).catch((error) => { console.log(error) });
    // }

    const handleEdit = (state) => {
        setEdit(true);
        setSelectedState(state);
    };

    const handleCloseDialog = () => {
        setEdit(false);
        setSelectedState(null);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    const HtmlTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: '#f5f5f9',
            color: 'rgba(0, 0, 0, 0.87)',
            maxWidth: 220,
            fontSize: theme.typography.pxToRem(12),
            border: '1px solid #dadde9',
        },
    }));

    const CommentTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: 'white',
            color: 'rgba(0, 0, 0, 0.87)',
            maxWidth: 550,
            fontSize: theme.typography.pxToRem(12),
            borderRadius: "6px",
            padding: "12px"
        },
    }));

    return (
        <div className={classes.generalInfoContainer}>
            <TableContainer>
                <Table aria-label="production order info" className={classes.table}>
                    <TableHead>
                        <TableRow>
                            <TableCell className={classes.tableHeader}>{t("Ordernummer")}</TableCell>
                            <TableCell className={classes.tableHeader}>{t("Date")}</TableCell>
                            <TableCell className={classes.tableHeader}>{t("Start/Stop")}</TableCell>
                            <TableCell className={classes.tableHeader}>{t("Boeking")}</TableCell>
                            <TableCell className={classes.tableHeader}>{t("Stilstand")}</TableCell>
                            <TableCell className={classes.tableHeader}>{t("Productie/Scrap")}</TableCell>
                            <TableCell className={classes.tableHeader}>{t("Grondstof")}</TableCell>
                            <TableCell className={classes.tableHeader}>{t("Remark")}</TableCell>
                            <TableCell className={classes.tableHeader} style={{ textAlign: "right" }}>{t("Output (kg/uur)")}</TableCell>
                            <TableCell className={classes.tableHeader} style={{ textAlign: "right" }}>{t("Snijafval (mm)")}</TableCell>
                            <TableCell className={classes.tableHeader} style={{ textAlign: "center" }}>{t("Edit")}</TableCell>
                        </TableRow>
                    </TableHead>
                    {rows?.length > 0 ? (
                        <TableBody>
                            {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((state, stateIndex) => (
                                <React.Fragment key={'Fragment_' + state.id + '_' + stateIndex}>
                                    {/* Check if the state is not SHIFTEND, display the regular row */}
                                    {state.state !== ProductionStateLogStates.SHIFTEND ? (
                                        <TableRow
                                            className={stateIndex === 0 ? classes.firstRow : classes.row}
                                            key={'ProductioStateLineKey_' + state.id + '_' + stateIndex}
                                            style={{ backgroundColor: stateIndex === 0 ? '#e5fdff !important' : '#f4fff5 !important' }}
                                        >
                                            <TableCell className={classes.firstCell}>
                                                <div style={{ display: 'flex', flexDirection: 'row', height: '100%' }}>
                                                    {(state.reference !== "" && state.reference !== null && state.reference !== undefined) && (
                                                        <HtmlTooltip
                                                            title={
                                                                <div>
                                                                    <div>{t('Extrudeur')}: {state.extrudeur}</div>
                                                                    {(state.packer !== "" && state.packer !== undefined) && (
                                                                        <div>{t('Verpakker')}: {state.packer}</div>
                                                                    )}
                                                                </div>
                                                            }
                                                        >
                                                            <InfoOutlinedIcon sx={{ paddingRight: '5px' }}></InfoOutlinedIcon>
                                                        </HtmlTooltip>
                                                    )}
                                                    <Typography>{state.reference || "-"}</Typography>
                                                </div>
                                            </TableCell>
                                            <TableCell className={classes.nameCell}>
                                                <Typography>{fromNewDateFormatToDDMMYYYYSlash(state.insertedOn)}</Typography>
                                                <Typography>{fromNewDateFormatToHHmmssSlash(state.insertedOn)}</Typography>
                                            </TableCell>
                                            <TableCell className={classes.nameCell}>{handleDisplayStateStartStopFinish(state.state)}</TableCell>
                                            <TableCell className={classes.nameCell}>
                                                <Typography>{state.bookingPallet || "-"}</Typography>
                                            </TableCell>
                                            <TableCell className={classes.nameCell}>{handleDisplayStateStandstill(state)}</TableCell>
                                            <TableCell className={classes.nameCell}>
                                                {(state.state === ProductionStateLogStates.SCRAP || state.state === ProductionStateLogStates.FINISH) ? (
                                                    <React.Fragment>
                                                        {handleDisplayStateProductionScrapUpper(state)}
                                                        {handleDisplayStateProductionScrapLower(state)}
                                                    </React.Fragment>
                                                ) : "-"}
                                            </TableCell>
                                            <TableCell className={classes.nameCell}>{handleDisplayGrondstof(state)}</TableCell>
                                            <TableCell className={classes.longTextCell}>
                                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: "start", height: '100%' }}>
                                                    {(state.comment !== "" && state.comment !== null && state.comment !== undefined) ? (
                                                        <CommentTooltip title={<div style={{ fontSize: "16px" }}>{state.comment}</div>}>
                                                            <div className={classes.commentText}>
                                                                {state.comment}
                                                            </div>
                                                        </CommentTooltip>
                                                    ) : "-"}
                                                </div>
                                            </TableCell>
                                            <TableCell className={classes.numberCell}>{state.output || "-"}</TableCell>
                                            <TableCell className={classes.numberCell}>{state.cuttingTrash || "-"}</TableCell>
                                            <TableCell className={classes.lastCell} style={{ textAlign: "center" }}>
                                                <Pencil className={classes.editIcon} onClick={() => handleEdit(state)} size={20}></Pencil>
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                        // Custom divider line for SHIFTEND
                                        <TableRow key={'Divider_' + state.id + '_' + stateIndex}>
                                            <TableCell className={classes.shiftDividerCell} colSpan={12}>
                                                <div className={classes.shiftDividerContainer}>
                                                    <div className={classes.shiftDividerLine} />
                                                    <p className={classes.shiftDividerText}>{t("End of shift")} - {formatShiftTime(state.insertedOn)}</p>
                                                    <div className={classes.shiftDividerLine} />
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </React.Fragment>
                            ))}
                        </TableBody>
                    )
                        : (<TableBody>Loading...</TableBody>)}
                </Table>
            </TableContainer>
            {rows?.length > 0 ? (
                <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            ) : (<React.Fragment></React.Fragment>)}
            {selectedState && <ProductionStateDialog dialogOpen={edit} productionState={selectedState} currentUserId={props.props.user.userInfo.sub} updateRows={updateRows} closeDialog={() => handleCloseDialog()}></ProductionStateDialog>}
        </div>
    );
}

const useStyles = makeStyles({
    generalInfoContainer: {
        padding: "10px",
        borderRadius: "6px",
    },
    editIcon: {
        padding: "4px",
        cursor: "pointer",

        "&:hover": {
            color: "#4654FB"
        }
    },
    firstCell: {
        padding: "3px !important",
        border: "none",
        paddingLeft: "15px !important",
        fontSize: "14",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
        borderTop: "1px solid #cfcfd0 !important",
        borderBottom: "1px solid #cfcfd0 !important",
        borderLeft: "1px solid #cfcfd0 !important",
        borderRadius: "5px 0 0 5px",

    },
    firstRow: {
        backgroundColor: '#e5fdff !important',
        border: '1px solid lightgrey'
    },
    table: {
        borderSpacing: '0px 4px',
        borderCollapse: 'separate'
    },
    row: {
        backgroundColor: '#f4fff5',
        border: '1px solid lightgrey'
        // '&:nth-of-type(odd)': {
        // backgroundColor: FlagstoneTheme.palette.action.hover,
        // },
    },
    lastCell: {
        padding: "8px !important",
        border: "none",
        fontSize: "14",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
        borderTop: "1px solid #cfcfd0 !important",
        borderBottom: "1px solid #cfcfd0 !important",
        borderRight: "1px solid #cfcfd0 !important",
        borderRadius: "0 5px 5px 0"
    },
    nameCell: {
        textAlign: "left",
        padding: "8px !important",
        border: "none",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
        borderTop: "1px solid #cfcfd0 !important",
        borderBottom: "1px solid #cfcfd0 !important",
    },
    longTextCell: {
        textAlign: "left",
        padding: "0px 8px !important",
        border: "none",
        fontFamily: "Lato, sans-serif",
        fontSize: "16px",
        fontWeight: 'medium',
        color: "#020100",
        borderTop: "1px solid #cfcfd0 !important",
        borderBottom: "1px solid #cfcfd0 !important",
        maxWidth: "550px",


    },
    commentText: {

        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "-webkit-box",
        "-webkit-box-orient": "vertical",
        "-webkit-line-clamp": "2",
    },
    numberCell: {
        textAlign: "right",
        padding: '8px !important',
        border: "none",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
        borderTop: "1px solid #cfcfd0 !important",
        borderBottom: "1px solid #cfcfd0 !important",
    },
    inputCell: {
        width: "100%",

    },
    arrowIcon: {
        height: "20px",
        paddingRight: '10px'
    },

    tableHeader: {
        padding: '8px'
    },

    shiftDividerCell: {
        padding: '10px 0',
        textAlign: 'center'
    },

    shiftDividerContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },

    shiftDividerLine: {
        flexGrow: 1,
        height: '1px',
        backgroundColor: FlagstoneTheme.palette.primary.main
    },

    shiftDividerText: {
        margin: '0',
        padding: '0 16px',
        fontSize: '14px',
        color: FlagstoneTheme.palette.primary.main
    },
});